<template>
    <div class="error-modal-component">
        <div class="error-modal">
            <h3>{{ errorTitle }}</h3>
            <p>{{ errorMessage }}</p>
            <p><button type="button" class="btn-danger btn" @click="closeMessage">Ok</button></p>
        </div>
    </div>
</template>

<script>
import {EventBus} from '@/event-bus.js';

export default {
    props: [
        'session',
        'errorTitle',
        'errorMessage'
    ],
    methods:{
        closeMessage(){
            EventBus.$emit('showError', false);
        }
    }
}
</script>
